import { Validator } from '@vista-digital/validator';
import { FieldFormatType } from '../../../../types/form/field-format-type';
import { numberFieldValidationConfigValidator, textFieldValidationConfigValidatorSchema } from '../../../../types/form/field-validation-config';
export const defaultTicketRedemptionCodeFormValidationConfig = {
    code: { required: true, type: FieldFormatType.Text, minLength: 4 },
    pin: { type: FieldFormatType.Number }
};
export const ticketRedemptionCodeFormValidationConfigValidator = Validator.object({
    code: Validator.object(Object.assign(Object.assign({}, textFieldValidationConfigValidatorSchema), { minLength: Validator.optional(Validator.number({ min: 0 })) })),
    pin: numberFieldValidationConfigValidator
});
